import Model, { attr } from '@ember-data/model';

export default class AirbnbQualityStatMonthModel extends Model {
  @attr('date') month!: Date;
  @attr('number') overallIssueTripRate!: number | null;
  @attr('number') hostCancellationRate!: number | null;
  @attr('number') cancellationsByHost!: number;
  @attr('number') tripsCsReportHighSeverity!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-quality-stat-month': AirbnbQualityStatMonthModel;
  }
}
